import { Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguagePreference } from "@/hooks/useLanguagePreference";
import { cn } from "@/lib/utils";
import { type ToggleTone, toggleTriggerClass } from "@/components/ui/toggle-tone";

interface LanguageToggleProps {
  /** Visual tone of the trigger button (see {@link ToggleTone}). */
  tone?: ToggleTone;
}

export function LanguageToggle({ tone = "default" }: LanguageToggleProps = {}) {
  const { language, setLanguage, isSaving } = useLanguagePreference();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className={toggleTriggerClass(tone)}
          disabled={isSaving}
        >
          <Languages className="h-4 w-4" />
          <span className="sr-only">Sprache wechseln</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => setLanguage("de")}
          className={cn(language === "de" && "bg-accent")}
        >
          🇩🇪 Deutsch
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setLanguage("en")}
          className={cn(language === "en" && "bg-accent")}
        >
          🇬🇧 English
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setLanguage("ja")}
          className={cn(language === "ja" && "bg-accent")}
        >
          🇯🇵 日本語
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
